/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForServiceNowOauthProtocol extends models.ServiceAccountCredentialsBaseForServiceNow {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForServiceNowOauthProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForServiceNowOauthProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForServiceNowOauthProtocol>): ServiceAccountCredentialsForServiceNowOauthProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForServiceNowOauthProtocol(), model);
        ServiceAccountCredentialsForServiceNowOauthProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForServiceNowOauthProtocol>): ServiceAccountCredentialsForServiceNowOauthProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForServiceNowOauthProtocol.newInstance(<ServiceAccountCredentialsForServiceNowOauthProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForServiceNowOauthProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForServiceNowOauthProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForServiceNowOauthProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForServiceNow.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForServiceNowOauthProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Client Id. This is a required field.
     */
    client_id: string;

    /**
     * Client Secret. This is a required field.
     */
    client_secret: string;

    /**
     * Grant Type. This is a required field.
     */
    grant_type: models.ServiceNowGrantType;

    /**
     * API Scope. This is a required field.
     */
    scope: models.ServiceNowAPIScope;

    /**
     * Token URL. This is a required field.
     */
    token_url: string;

}
